import { parseItemDetails } from './formatters';
import { GHOST_DATA } from './ghostData.generated';

const slug = (s: string): string => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const getGhostSrc = (name: string): string => {
  const { weaponName, condition } = parseItemDetails(name);
  const key = slug(weaponName);
  if (GHOST_DATA[key]) return GHOST_DATA[key];
  if (key === 'package' || key === 'collection') return GHOST_DATA['case'];
  if (!condition && name.includes(' | ')) return GHOST_DATA['agent'];
  return GHOST_DATA['default'];
};
